module.exports = __webpack_public_path__ + "static/media/chrisCardBack.35ed81a0.png";